import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONSTANTES_SESION } from '../_util/services-util';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Agregar encabezado de autorización con token jwt si está disponible
        const currentUser = sessionStorage.getItem(CONSTANTES_SESION.TOKEN);
        if (currentUser) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${ currentUser.replace('CRM:','') }`
                }
            });
        }
        return next.handle(request);
    }
}

export const JwtInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true,
};
